import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const monitoringDocumentsApi = {
    getMonitoringDocuments: (): Observable<Dtos.GetMonitoringDocumentsResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringDocuments = new Dtos.GetMonitoringDocuments();

        //Send request.
        const response: Promise<Dtos.GetMonitoringDocumentsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringDocumentsByMonitoringId: (monitoringId: number): Observable<Dtos.GetMonitoringDocumentsByMonitoringIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringDocumentsByMonitoringId = new Dtos.GetMonitoringDocumentsByMonitoringId();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.GetMonitoringDocumentsByMonitoringIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringDocumentById: (id: number): Observable<Dtos.GetMonitoringDocumentByIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringDocumentById = new Dtos.GetMonitoringDocumentById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetMonitoringDocumentByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setMonitoringDocument: (monitoringDocument: Dtos.MonitoringDocument): Observable<Dtos.SetMonitoringDocumentResponse> => {

        let request: Dtos.SetMonitoringDocument = new Dtos.SetMonitoringDocument();

        request.monitoringDocument = monitoringDocument;

        // send request
        const response: Promise<Dtos.SetMonitoringDocumentResponse> = client.post(request);

        return Observable.from(response);
    },
    createMonitoringDocument: (monitoringId: number): Observable<Dtos.CreateMonitoringDocumentResponse> => {
        //Create the request.
        let request: Dtos.CreateMonitoringDocument = new Dtos.CreateMonitoringDocument();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.CreateMonitoringDocumentResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateMonitoringDocument: (monitoringDocument: Dtos.MonitoringDocument): Observable<Dtos.ValidateMonitoringDocumentResponse> => {

        let request: Dtos.ValidateMonitoringDocument = new Dtos.ValidateMonitoringDocument();

        request.monitoringDocument = monitoringDocument;

        // send request
        const response: Promise<Dtos.ValidateMonitoringDocumentResponse> = client.post(request);

        return Observable.from(response);
    }
}